import { Badge, Stack, Text } from "@mantine/core";
import type { AssistantVoiceText } from "@/locales/assistant-voice";
import type { VoiceStatus } from "@/store/assistant-voice";
import type { WallMicState, WallNocMicMode } from "@/types/ai-assistant-voice";
import { fillTemplate } from "../assistant.logic";
import { nocBadge, pttEnabled, showsPttButton } from "./voice-noc.logic";
import { VoicePttButton } from "./voice-ptt-button";

interface Props {
	t: AssistantVoiceText;
	name: string;
	micMode: WallNocMicMode;
	status: VoiceStatus;
	wallMic: WallMicState | null;
	held: boolean;
	onPress(): void;
	onRelease(): void;
}

/** Kontrol suara Mode NOC di /wall: lencana mikrofon, tombol bicara, dan catatan teks. */
export function VoiceNocControls({
	t,
	name,
	micMode,
	status,
	wallMic,
	held,
	onPress,
	onRelease,
}: Props) {
	const badge = nocBadge(wallMic ?? "closed", t, name);
	return (
		<Stack gap={6} mx="sm" my={6} data-noc-controls>
			<Badge
				size="xl"
				radius="md"
				variant="filled"
				color={badge.color}
				fullWidth
				role="status"
				aria-live="polite"
				data-mic-badge={wallMic ?? "closed"}
			>
				{badge.label}
			</Badge>
			{showsPttButton(micMode) ? (
				<VoicePttButton
					t={t}
					held={held}
					enabled={pttEnabled(status)}
					onPress={onPress}
					onRelease={onRelease}
				/>
			) : null}
			{micMode !== "ptt" ? (
				<Text size="xs" c="dimmed" ta="center">
					{fillTemplate(t.noc.autoMuteHint, { name })}
				</Text>
			) : null}
			<Text size="xs" c="dimmed" ta="center">
				{t.noc.typedNotRead}
			</Text>
		</Stack>
	);
}
